<template>
  <div>
    <b-overlay :show="isLoading" rounded="lg">
      <div v-if="!isLoading && !items.length" class="support-empty">
        <feather-icon icon="PhoneCallIcon" size="28" />
        <span>در حال حاضر تماس فعالی وجود ندارد.</span>
      </div>

      <div v-for="item in items" :key="item.id" class="support-item">
        <div class="support-item__who">
          <b-avatar variant="light-success" size="40">
            <feather-icon icon="PhoneCallIcon" />
          </b-avatar>
          <div class="support-item__text">
            <div class="support-item__name">{{ item.studentFullName || `زبان‌آموز #${item.studentId}` }}</div>
            <small class="text-muted">پشتیبان: {{ item.teacherFullName || "-" }}</small>
          </div>
        </div>

        <div class="support-item__meta">
          <div>رزروشده: <strong>{{ formatHours(item.capacityTime) }}</strong></div>
          <div>
            استفاده‌شده: <strong>{{ formatMinutes(item.usedTime) }}</strong>
            · باقی‌مانده: <strong>{{ formatMinutes(remaining(item)) }}</strong>
          </div>
          <div v-if="supportExpireDate(item)">اعتبار تا: <strong>{{ formatDate(supportExpireDate(item)) }}</strong></div>
        </div>

        <!-- مدت همین تماس به دقیقه -->
        <b-form-group label="مدت تماس (دقیقه)" :label-for="`used-${item.id}`" class="support-item__picker">
          <b-form-input
            :id="`used-${item.id}`"
            v-model.number="durations[item.id]"
            type="number"
            min="1"
            :max="remaining(item)"
            placeholder="مثلا ۴۵"
          />
        </b-form-group>

        <b-button
          variant="success"
          class="support-item__action"
          :disabled="!isValidDuration(item) || isSaving"
          @click="confirmUsed(item)"
        >
          ثبت مدت تماس
        </b-button>
      </div>
    </b-overlay>

    <div v-if="total > count" class="d-flex justify-content-center mt-2">
      <b-pagination v-model="pageNumber" :total-rows="total" :per-page="count" first-number last-number />
    </div>
  </div>
</template>

<script>
import { BOverlay, BAvatar, BButton, BPagination, BFormGroup, BFormInput } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { GetSupportAdminList, MarkSupportTimeUsed, SUPPORT_STATUS } from "@/libs/Api/SupportLesson";
import { formatHours, formatMinutes, formatDate, supportExpireDate } from "./supportFormat";

export default {
  name: "SupportActiveList",
  components: { BOverlay, BAvatar, BButton, BPagination, BFormGroup, BFormInput },
  emits: ["changed"],
  data() {
    return {
      isLoading: false,
      isSaving: false,
      items: [],
      total: 0,
      count: 10,
      pageNumber: 1,
      // supportLessonId → دقیقه‌ی واردشده
      durations: {},
    };
  },
  watch: {
    pageNumber() {
      this.load();
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    supportExpireDate,
    formatHours,
    formatMinutes,
    formatDate,
    remaining(item) {
      return Math.max(0, Number(item.capacityTime || 0) - Number(item.usedTime || 0));
    },
    isValidDuration(item) {
      const value = Number(this.durations[item.id]);
      return Number.isInteger(value) && value > 0 && value <= this.remaining(item);
    },
    async load() {
      this.isLoading = true;
      try {
        const req = new GetSupportAdminList(this);
        req.setRequestParam({ count: this.count, pageNumber: this.pageNumber, status: SUPPORT_STATUS.assigned });
        await req.get((res) => {
          const data = (res && res.data) || {};
          this.items = data.data || [];
          this.total = Number(data.total || 0);
        });
      } catch (error) {
        console.error(error);
        this.toast("دریافت تماس‌ها انجام نشد", "danger");
      } finally {
        this.isLoading = false;
      }
    },
    async confirmUsed(item) {
      const minutes = Number(this.durations[item.id]);
      const ok = await this.$bvModal.msgBoxConfirm(
        `${formatMinutes(minutes)} تماس برای ${item.studentFullName || "این زبان‌آموز"} با پشتیبان ${item.teacherFullName || ""} ثبت شود؟`,
        { title: "تأیید ثبت مدت تماس", okTitle: "ثبت", cancelTitle: "انصراف", centered: true, okVariant: "success" }
      );
      if (ok) this.saveUsed(item, minutes);
    },
    async saveUsed(item, minutes) {
      this.isSaving = true;
      try {
        let isOk = false;
        const req = new MarkSupportTimeUsed(this);
        req.setRequestParamDataObj({ supportLessonId: item.id, usedTime: minutes });
        await req.fetch((res) => {
          isOk = !!(res && res.isSuccess);
        });
        if (!isOk) throw new Error("mark failed");
        this.toast("مدت تماس ثبت شد", "success");
        this.$delete(this.durations, item.id);
        this.$emit("changed");
        this.load();
      } catch (error) {
        console.error(error);
        this.toast("ثبت مدت تماس انجام نشد", "danger");
      } finally {
        this.isSaving = false;
      }
    },
    toast(title, variant) {
      this.$toast({
        component: ToastificationContent,
        props: { title, icon: variant === "success" ? "CheckIcon" : "AlertTriangleIcon", variant },
      });
    },
  },
};
</script>

<style scoped src="./supportList.css"></style>
